<ng-container *ngIf="data.hasData()">
  <p>{{ 'producer' | translate }}: {{ data.getProducer() || '-' }}</p>
  <p>
    {{ 'cat-nr' | translate }}: {{ data.getCatalogNumber() || '-' }} /
    {{ data.getPartType() ? (data.getPartType() | translate) : '-' }}
  </p>
  <p *ngIf="data.getDescription() as description">{{ 'description' | translate }}: {{ description }}</p>
</ng-container>
